import { Button, DialogTitle, FormControl, FormLabel, Input, Modal, ModalDialog, Stack, Textarea } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import { IOffer } from '../interface/IOffer';
import offerApi from '../api/offer';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  selectedOffer: IOffer | null;
};

const OrderedOfferModal = ({ open, onClose, onSave, selectedOffer }: Props) => {
  const [offer, setOffer] = useState<Partial<IOffer>>({});

  useEffect(() => {
    if (open) {
      if (selectedOffer) {
        setOffer({
          offerId: selectedOffer.offerId,
          title: selectedOffer.title,
          contractNumber: selectedOffer.contractNumber,
          orderDate: selectedOffer.orderDate,
          invoiceToName: selectedOffer.invoiceToName,
          invoiceToStreet: selectedOffer.invoiceToStreet,
          invoiceToCity: selectedOffer.invoiceToCity,
          invoiceToPostalCode: selectedOffer.invoiceToPostalCode,
          invoiceToCountryCode: selectedOffer.invoiceToCountryCode,
          invoiceToEmail: selectedOffer.invoiceToEmail,
          invoiceToEmailCc: selectedOffer.invoiceToEmailCc,
        });
      }
    } else {
      setOffer({});
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby='modal-title'
      aria-describedby='modal-desc'
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <ModalDialog>
        <DialogTitle>Offer: {offer.title}</DialogTitle>
        <form
          onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            try {
              const formData = new FormData(event.currentTarget);
              const formJson: IOffer = Object.fromEntries((formData as any).entries()) as IOffer;
              // if (offer.projectId) {
              //   const res = await projectApi.updateProject(Number(project.projectId), formJson);
              // } else {
              // }
              await offerApi.orderedOffer(offer.offerId!, formJson);
              onSave();
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <Stack spacing={2}>
            <FormControl required>
              <FormLabel>Contract Number</FormLabel>
              <Input
                type='text'
                name='contractNumber'
                value={offer?.contractNumber || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, contractNumber: e.target.value as string }))}
              />
            </FormControl>
            <FormControl required>
              <FormLabel>Order Date</FormLabel>
              <Input
                name='orderDate'
                type='date'
                value={offer?.orderDate || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, orderDate: e.target.value }))}
              />
            </FormControl>
            <FormControl required>
              <FormLabel>Invoice To Email</FormLabel>
              <Input
                type='email'
                name='invoiceToEmail'
                value={offer?.invoiceToEmail || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, invoiceToEmail: e.target.value as string }))}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Invoice To Email CC</FormLabel>
              <Input
                name='invoiceToEmailCc'
                value={offer?.invoiceToEmailCc || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, invoiceToEmailCc: e.target.value as string }))}
              />
            </FormControl>
            <FormControl required>
              <FormLabel>Invoice To Address</FormLabel>
              <Textarea
                name='invoiceToName'
                value={offer?.invoiceToName || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, invoiceToName: e.target.value as string }))}
                placeholder='Name'
              />
            </FormControl>
            <FormControl required>
              <Textarea
                name='invoiceToStreet'
                value={offer?.invoiceToStreet || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, invoiceToStreet: e.target.value as string }))}
                placeholder='Street'
              />
            </FormControl>
            <FormControl required>
              <Textarea
                name='invoiceToCity'
                value={offer?.invoiceToCity || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, invoiceToCity: e.target.value as string }))}
                placeholder='City'
              />
            </FormControl>
            <FormControl required>
              <Textarea
                name='invoiceToPostalCode'
                value={offer?.invoiceToPostalCode || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, invoiceToPostalCode: e.target.value as string }))}
                placeholder='Postal Code'
              />
            </FormControl>
            <FormControl required>
              <Textarea
                name='invoiceToCountryCode'
                value={offer?.invoiceToCountryCode || ''}
                onChange={(e) => setOffer((prev) => ({ ...prev, invoiceToCountryCode: e.target.value as string }))}
                placeholder='Country Code'
              />
            </FormControl>
            <Button type='submit'>Submit</Button>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default OrderedOfferModal;
